define.alias("shared/modifiers/circular-upload-animation", "settings/modifiers/circular-upload-animation");